<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text class="pa-5">
        <v-form ref="form" v-show="showComponent">
          <v-row justify="space-around">
            <v-col cols="12" md="4">
              <h3 class="font-weight-bold">
                {{ edit ? $t("book/facility:facility.dashboard.information.processes.title-edit") : $t("buttons:add-specific", { specific: $t('common:process')}) }}
              </h3>
            </v-col>
            <v-col cols="12" md="6"></v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="12" md="4">

              <!-- General Section -->
              <h4 class="primary--text">{{ $t('common:general') }}</h4>
              <!-- Select for selecting process which should be assigned-->
              <v-select
                  outlined
                  v-model="processJob.process"
                  :label="$t('common:process')"
                  :hint="$t('book/facility:facility.dashboard.information.processes.hints.process')"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  :items="restProcess"
                  item-text="name"
                  item-value="id"
                  persistent-hint
                  class="mb-1"
                  @change="updateProcessInfo(true)"
                  tabindex="76"
              />

              <div class="horizontal-container mb-4">
                <v-icon>info_outline</v-icon>
                <p class="my-0 ml-1">{{ $t('book/facility:facility.dashboard.information.processes.labels.required-role') + requiredRoleName }}</p>
              </div>
              <!-- Select for selecting user for process -->
              <v-select
                  clearable
                  outlined
                  v-model="processJob.assignedTo"
                  :label="$t('common:user') + ' (Opt.)'"
                  :hint="$t('book/facility:facility.dashboard.information.processes.hints.user')"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="restUser"
                  item-text="name"
                  item-value="id"
                  persistent-hint
                  class="mb-1"
                  :disabled="typeof processJob.process == 'undefined' || processJob.process == null"
                  tabindex="77"
              />
              <!-- disable checkbox since sproof is not available
              <v-checkbox
                  color="secondary"
                  v-model="processJob.requiresSignature"
                  :label="$t('book/facility:facility.dashboard.information.processes.labels.requiresSignature')"
                  tabindex="78"
              />
              -->

              <v-checkbox
                  color="secondary"
                  v-model="processJob.requiresRideCount"
                  :label="$t('book/facility:facility.dashboard.information.processes.labels.requires-ride-count')"
                  tabindex="79"
              />

              <v-checkbox
                  color="secondary"
                  v-model="processJob.requiresFileNumber"
                  :label="$t('book/facility:facility.dashboard.information.processes.labels.requires-file-number')"
                  tabindex="80"
              />

              <v-checkbox
                  color="secondary"
                  v-model="processJob.disableDeadline"
                  :label="$t('book/facility:facility.dashboard.information.processes.labels.disable-deadline')"
              />

              <!-- Management Section -->
              <h4 class="primary--text mt-5">{{ $t('book/facility:facility.dashboard.information.processes.titles.management') }}</h4>
              <!--  Date Picker as TextField -->
              <DateField
                  ref="date"
                  @update="(v) => (processJob.date = v)"
                  :isClearable="true"
                  :label="$t('common:date')"
                  :hint="$t('book/facility:facility.dashboard.information.processes.hints.date')"
                  :onlyFuture="true"
                  :is-required="true"
                  tabindex="81"
              />
              <div class="horizontal-container">
                <v-icon>info_outline</v-icon>
                <p class="my-0 ml-1">{{ $t('book/facility:facility.dashboard.information.processes.labels.buffers') + buffers }}</p>
              </div>
              <div class="horizontal-container mb-4">
                <v-icon>info_outline</v-icon>
                <p class="my-0 ml-1">{{  timespanString  }}</p>
              </div>
              <div v-if="repeatEveryDays !== 0" class="horizontal-container mb-4">
                <v-icon>info_outline</v-icon>
                <p class="my-0 ml-1">{{ $t('book/facility:facility.dashboard.information.processes.labels.repeating-days', {days: repeatEveryDays}) }}</p>
              </div>
              <div v-if="repeatEveryMonthOnDay !== 0" class="horizontal-container mb-4">
                <v-icon>info_outline</v-icon>
                <p class="my-0 ml-1">{{ $t('book/facility:facility.dashboard.information.processes.labels.repeating-month', {day: repeatEveryMonthOnDay}) }}</p>
              </div>

              <v-select
                  :items="restProcessSteps"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ bottom: true, offsetY: true }"
                  v-model="processJob.excludedSteps"
                  outlined
                  multiple
                  chips
                  :label="$t('book/facility:facility.dashboard.information.processes.labels.excluded-steps')"
                  clearable
                  :disabled="processJob.process === undefined || processJob.process === null"
                  :rules="[ruleNotAllSelected($t('utils:rules.select-all'),restProcessSteps.length)]"
                  tabindex="82"
              />

              <BaseButton
                  color="primary"
                  :btnText="edit ? $t('book/facility:facility.dashboard.information.processes.title-edit') : $t('buttons:add-specific', { specific: $t('common:process')})"
                  @clickedButton="updateForm()"
              />

              <TwoButtonDialog
                  v-if="edit"
                  ref="deleteButton"
                  :btn-text="$t('buttons:delete')"
                  color="errorDark"
                  :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/facility:facility.dashboard.information.processes.dialogs.part-1')})"
                  :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/facility:facility.dashboard.information.processes.dialogs.part-2')})"
                  :button1-text="$t('buttons:cancel')"
                  :button2-text="$t('buttons:delete')"
                  @clickedButton1="$refs.deleteButton.showDialog = false"
                  @clickedButton2="deleteProcessJob()"
                  hideOverlay
              />

              <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:cancel')"
                  color="grey"
                  :dialog-title="$t('dialog:dirty-save-btn-title')"
                  :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="closeDialog"
                  :dataToWatch="processJob"
                  hideOverlay
              />
            </v-col>
            <v-col cols="12" md="6">
              <!-- Documentation Section -->
              <h4 class="primary--text">{{ $t('common:document_plural') }}</h4>
              <!-- Dialog to confirm if document should be deleted -->
              <TwoButtonDialog
                  ref="dialogDeleteDocumentation"
                  :hide-button="true"
                  :btn-text="$t('buttons:delete')"
                  color="errorDark"
                  :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/facility:facility.dashboard.information.processes.documentation.dialog-1')})"
                  :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/facility:facility.dashboard.information.processes.documentation.dialog-2')})"
                  :button1-text="$t('buttons:cancel')"
                  :button2-text="$t('buttons:delete')"
                  @clickedButton1="deleteDocumentationConfirmed()"
                  @clickedButton2="$refs.dialogDeleteDocumentation.showDialog = false"
                  hideOverlay
              />
              <DataTablePaginated
                  ref="tableDocuments"
                  class="ma-1"
                  :headers="docuHeaders"
                  @updateTableData="updateDocuTable"
                  icon="visibility"
                  icon2="cloud_download"
                  icon3="delete"
                  :iconTooltip="$t('buttons:show')"
                  :iconTooltip2="$t('buttons:download')"
                  :iconTooltip3="$t('buttons:delete')"
                  @clickedButton1="viewDocumentation"
                  @clickedButton2="downloadDocumentation"
                  @clickedButton3="deleteDocumentation"
                  sortBy="name"
                  disableSearch
              />

              <DocumentViewer hide-overlay ref="documentViewer"/>

              <div v-show="edit">
                <h4 class="primary--text font-weight-medium mt-5">{{ $t('common:status') }}</h4>
                <LabelField
                    :label="$t('book/facility:facility.dashboard.information.processes.labels.assigned-to')"
                    :value="isAssignedTo"
                />

                <LabelField
                    :label="$t('common:status')"
                    :value="isAccepted"
                />

                <v-card flat disabled>
                  <v-row justify="start">
                    <v-col cols="12" lg="5" class="pb-0">
                      <span
                          class="font-weight-bold">{{ $t('book/facility:facility.dashboard.information.processes.labels.rejected-by') + ':' }}</span>
                    </v-col>
                    <v-col cols="12" lg="7" v-if="processJob">
                      <div v-for="(name, index) in processJob.rejectedByUsersNames" :key="index" class="font-weight-medium">
                        {{ name }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

import ProcessService from '@/modules/book/services/process/impl/process-service';
import UserService from '@/modules/core/services/users-service';
import ProcessJobService from '@/modules/book/services/process/impl/process-job-service';
import DocumentationService from "@/modules/core/services/documentation-service";

import Utils from '@/modules/core/services/utils';
import DataUtils from "@/modules/core/services/data-utils";
import {ruleRequired, ruleNotAllSelected } from "@/modules/core/services/rules"

import ProcessJob from '@/modules/book/data/processJob'
import Process from '@/modules/book/data/process'
import Users from '@/modules/core/data/users'
import ProcessStep from '@/modules/book/data/processStep'

import DateField from '@/modules/core/components/DateField';
import DataTablePaginated from "@/modules/core//components/DataTable/DataTablePaginated";
import LabelField from "@/modules/core/components/LabelField";
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";

import {mapGetters} from 'vuex';
import DateUtils from "@/modules/core/services/date-utils";
import WorkerRoleService from "@/modules/core/services/worker-role-service";
import WorkerRole from "@/modules/core/data/worker-role";

export default {
  name: 'FacilityProcessDialogForm',
  components: {
    DataTablePaginated,
    LabelField,
    DateField,
    TwoButtonDialog,
    DocumentViewer: () => import('@/modules/core/components/DocumentViewer/DocumentViewer'),
    BaseButton,
    DirtyConfirmButtonDialog
  },
  data() {
    return {
      valid: false,
      edit: false,
      dialog: false,

      processJob: new ProcessJob(),
      restProcess: [],
      restProcessSteps: [],
      restUser: [],
      restWorkerRoles: [],
      restDocu: [],

      requiredRoleName: "",
      startBuffer: 0,
      endBuffer: 0,
      repeatEveryDays: 0,
      repeatEveryMonthOnDay: 0,

      isAccepted: null,
      isAssignedTo: null,

      deleteDocuId: null,
      isFetchingJob: true,

      tableOptions: [],
      tableSearch: []
    }
  },
  computed: {
    docuHeaders() {
      return [
        {text: this.$t("common:type"), value: "translatedType"},
        {text: this.$t('common:document-name'), value: "name"},
        {text: this.$t('common:valid-from'), value: "startDate"},
        {text: this.$t('common:valid-until'), value: "endDate"},
        {text: "", value: "controls", width: "200px"}
      ];
    },
    currentLang() {
      return this.$store.state.translation.language;
    },
    showComponent() {
      if(this.edit) {
        return !this.isFetchingJob;
      } else {
        return true
      }
    },
    buffers() {
      if (this.processJob && this.processJob.process) {
        return this.startBuffer + ' / ' + this.endBuffer;
      }
      return "";
    },
    timespanString() {
      let timespanString= this.$t('book/facility:facility.dashboard.information.processes.labels.timespan');
      let singleDateString= this.$t('book/facility:facility.dashboard.information.processes.labels.single-date');
      let dateValid;
      try {
        // just transform date-string of format 'dd.MM.yyyy' to Date-Object (and add 0 days)
        // if date-string is not convertible, this throws an error
        DateUtils.addDaysToDate(this.processJob.date, 0);
        dateValid = true;
      } catch (e) {
        dateValid = false;
      }
      let date = dateValid ? this.processJob.date : '';
      if (this.processJob && this.processJob.process) {  // process is selected therefore we have the start- & end-buffer
        if (this.startBuffer === 0 && this.endBuffer === 0) {
          return singleDateString + date;
        }
        try {
          let startDate =  DateUtils.addDaysToDate(this.processJob.date, -this.startBuffer);
          let endDate =    DateUtils.addDaysToDate(this.processJob.date, this.endBuffer);
          return timespanString + startDate + " - " + endDate;
        } catch(e) {
          return timespanString; // invalid date-string
        }
      }
      return singleDateString + date;
    }
  },
  methods: {
    ruleRequired,
    ruleNotAllSelected,
    ...mapGetters('auth', ['isAdmin']),

    closeDialog() {
      this.dialog = false;
      this.$refs.form.reset();
      this.$refs.date.localDate = ''
      this.$refs.date.maskedDate = ''
    },

    // open dialog with cleared input fields
    addProcess(options, search) {
      // this.$refs.form.reset();
      this.tableOptions = options;
      this.tableSearch = search;
      this.edit = false;
      this.$refs.date.maskedDate = DateUtils.getCurrentDateAsDEString();
      this.dialog = true;
    },

    // open dialog to edit processJob
    editProcess(item, options, search) {
      this.tableOptions = options;
      this.tableSearch = search;
      this.edit = true;
      this.dialog = true;

      ProcessJobService.readFromAPI(item.id,
        (resp) => {
          this.processJob = DataUtils.parseDataToSingleObject(resp.data, ProcessJob);
          this.isFetchingJob = false;
          this.isAssignedTo = this.processJob.assignedToName;

          if (this.processJob.accepted) {
            this.isAccepted = this.$t('book/facility:facility.dashboard.information.processes.values.accepted');
          } else {
            this.isAccepted = this.$t('book/facility:facility.dashboard.information.processes.values.not-accepted');
          }

          if (this.processJob.date) {
            this.processJob.date = this.$refs.date.parseDTO(this.processJob.date)
          }

          this.$refs.dirtyDialog.startWatch();

          this.updateProcessInfo(false);
        },
        (error) => {
          this.$logger.error("Error at ProcessJobService.readFromAPI: " + error);
          this.$router.push('/404')
        }
      )
    },

    updateForm() {
      if (!this.$refs.form.validate()) {
        // TODO scroll to specific form field which doesnt require the rules
        window.scrollTo(0, 0);
        return;
      }

      this.processJob.documentations = [];
      if (this.restDocu && this.restDocu.length > 0) {
        this.restDocu.forEach((object) => {
          this.processJob.documentations.push(object.id);
        })
      }

      this.processJob.facility = this.$route.params.id;

      if (!this.edit) {
        ProcessJobService.postToAPI(this.processJob,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}));
            this.$emit('updateProcessData', this.tableOptions, this.tableSearch)
            this.closeDialog();
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}))
          }
        );
      } else {
        ProcessJobService.putToAPI(this.processJob,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}));
            this.$emit('updateProcessData', this.tableOptions, this.tableSearch)
            this.closeDialog();
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}))
          }
        );
      }
    },

    deleteProcessJob() {
      this.$refs.deleteButton.setButtonSettings(true, true, false, true);
      ProcessJobService.deleteFromAPI(this.processJob, !this.isAdmin,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}));
          this.closeDialog();
          this.$emit('updateProcessData', this.tableOptions, this.tableSearch)
        },
        () => {
          this.$refs.deleteButton.setButtonSettings(false, false, false, false);
          this.$refs.deleteButton.showDialog = false;
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.process')}))
        }
      )
    },

    // Different API calls
    deleteDocumentation(data) {
      this.deleteDocuId = data.id;
      this.$refs.dialogDeleteDocumentation.showDialog = true;
    },
    deleteDocumentationConfirmed() {
      this.$refs.dialogDeleteDocumentation.setButtonSettings(false, false, false, false);
      this.$refs.dialogDeleteDocumentation.showDialog = false;
      Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('common:documentation')}));

      this.restDocu = this.restDocu.filter(entry => entry.id !== this.deleteDocuId);
      this.deleteDocuId = null;
    },

    downloadDocumentation(data) {
      DocumentationService.downloadFile(data.id, data.fileName, data.fileType, data.facilityId, data.documentType);
    },

    viewDocumentation(data) {
      this.$refs.documentViewer.initViewerById(this.restDocu, data.id, data.facilityId, data.documentType);
    },
    cleanupProcessVariables() {
      this.requiredRoleName = "";
      this.startBuffer =  0;
      this.endBuffer =  0;
      this.repeatEveryDays = 0;
      this.repeatEveryMonthOnDay = 0;
    },

    updateProcessInfo(clearExcludedSteps) {
      this.cleanupProcessVariables();
      if(this.processJob.process){
        //update the user information depending on selected process
        for(let i = 0; i < this.restProcess.length; i++){
          if(this.restProcess[i].id === this.processJob.process){
            let roleId = this.restProcess[i].role;
            let requiredRole= this.restWorkerRoles.find( val => roleId === val.id);
            this.requiredRoleName = requiredRole ? (requiredRole.name ? requiredRole.name : "") : "";
            this.startBuffer = this.restProcess[i].startBuffer ? this.restProcess[i].startBuffer : 0;
            this.endBuffer = this.restProcess[i].endBuffer ? this.restProcess[i].endBuffer : 0;
            this.repeatEveryDays = this.restProcess[i].repeatEveryDays ? this.restProcess[i].repeatEveryDays : 0;
            this.repeatEveryMonthOnDay = this.restProcess[i].repeatEveryMonthOnDay ? this.restProcess[i].repeatEveryMonthOnDay : 0;

            UserService.readUsersByFacilityAndRole(this.$route.params.id, roleId,
              (res) => {
                this.restUser = DataUtils.parseDataToObjectArray(res.data, Users);
              },
              (error) => {
                this.$logger.error("Error at getting Users: " + error);
                Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:user')}))
              }
            )
            break;
          }
        }

        //update the process steps depending on selected process
        ProcessService.readProcessStepsFromAPI(this.processJob.process,
          (res) => {
            this.restProcessSteps = DataUtils.parseDataToObjectArray(res.data, ProcessStep);
            if(clearExcludedSteps){
              this.processJob.excludedSteps = [];
            }
          },
          (error) => {
            this.$logger.error("Error at getting ProcessSteps: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:process-step_plural')}))
          }
        )
      }
    },

    //the first time we create the process, we can set what documents we want to show to the user
    updateDocuTable(options, search, filter) {
      if(!search) search = '';
      if(!filter) filter = '';
      this.$refs.tableDocuments.loading = true;
      DocumentationService.readPageableFacilityDocumentationsFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        filter,
        "ALL",
        options.sortBy,
        options.sortDesc,
        (resp) => {
          resp.data.content.forEach((document) => {
            document.translatedType = this.$t('enums:facility-documentation-types.' + document.type)

            if (document.type === 'CONTRACT') {
              document.name = this.$t('enums:contract-types.' + document.name)
            }
          })

          if(this.$refs.tableDocuments !== undefined) {
            this.$refs.tableDocuments.fillTableData(resp.data);
            this.restDocu = resp.data.content;
          }
        },
        (error) => {
          this.$refs.tableDocuments.loading = false;
          this.$logger.error("Error at getting documentations: " + error);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:document_plural')}))
        }
      )
    },

  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      });
    },
    dialog() {
      if(this.dialog) {
        this.cleanupProcessVariables();
        ProcessService.readAllFromAPI(
          (res) => {
            this.restProcess = DataUtils.parseDataToObjectArray(res.data, Process);
          },
          (error) => {
            this.$logger.error("Error at getting Processes: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/facility:facility.dashboard.information.processes.snackbar.processes')}))
          }
        )
        WorkerRoleService.readAllFromAPI(
            (res) => {
              this.restWorkerRoles = DataUtils.parseDataToObjectArray(res.data, WorkerRole);
            }
        )
        if(!this.edit) {
          this.$refs.dirtyDialog.startWatch();
        }
      }
    }
  }
}
</script>
<style scoped>
  .horizontal-container {
    display: flex;
    flex-direction: row;
    align-content: center;
  }
</style>